import i18n from '@/lib/i18n';
import { MerchandisingCollectionSlice } from '@/services/MerchandisingCollectionsService';

type SliceStatus = {
  color: string;
  text: string;
};

export function getSliceStatus(
  slice: Pick<MerchandisingCollectionSlice, 'startsAt' | 'endsAt'>,
): SliceStatus {
  const { startsAt, endsAt } = slice;
  const now = new Date();

  if (now < new Date(startsAt)) {
    return {
      color: '#eab308',
      text: i18n.t('pages.MerchandisingCollections.sliceStatus.scheduled'),
    };
  }

  if (now > new Date(endsAt)) {
    return {
      color: '#ef4444',
      text: i18n.t('pages.MerchandisingCollections.sliceStatus.expired'),
    };
  }

  return {
    color: '#22c55e',
    text: i18n.t('pages.MerchandisingCollections.sliceStatus.active'),
  };
}
